import { UtilitarioService } from '@app/services/utilitario.service';

export class PesquisaRelatorio {

  ParticipanteCodigo: number;
  ParticipanteNome: string;
  PagasRecebidas: boolean;
  NaoPagasRecebidas: boolean;
  ProcessoId: number;
  SomenteLiberadas: boolean;
  //SomenteNaoGerouAgrupamento: boolean;
  SomenteValidadas: boolean;
  DataInicial: string;
  DataFinal: string;
  Pagina: number;
  UnidadeId: number;
  Observacao: string;
  TipoData: string;

  constructor(colocarData = true) {
    this.PagasRecebidas = false;
    this.NaoPagasRecebidas = true;
    this.SomenteLiberadas = true;
    //this.SomenteNaoGerouAgrupamento = true;
    this.ParticipanteCodigo = 0;
    this.ProcessoId = 0;
    this.UnidadeId = 0;
    this.SomenteValidadas = false;
    this.TipoData = 'Vencimento';
    if (colocarData) {
      this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
      this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(7);
    } else {
      this.DataFinal = '';
      this.DataInicial = '';
    }
  }

}
